export default __webpack_public_path__ + "static/5.2.20_factor_chair_settings_Factor.457_09242020-aacb7ea14a788379983d971ea60f1b70.jpg";